/**
 * @author lifei &
 * 模块说明：用户中心
 */

// 供应商管理
import { SupplierService } from './supplier'

// 客户管理
import { CustomerService } from './customer'

// 客户授信
import { CustomerCreditService } from './customerCredit'

//客户公司信息
import { CustomerCompanyService } from './company'

//基础项目材料
import { BaseProjectDataService } from './baseProjectData'

export const supplier = new SupplierService('/api/customer/supplier')
export const customer = new CustomerService('/api/customer/customer')
export const customerCredit = new CustomerCreditService('/api/customer/customerCredit')
export const company = new CustomerCompanyService('/api/customer/company')
export const baseProjectData = new BaseProjectDataService('/api/customer/baseProjectData')
